import { View } from "binder"
import { CreateWarehouseKeepingViewModel } from "./createWarehouseKeeping-viewModel"
import { WarehouseSelectorViewModel } from "src/Warehouse/warehouseManipulation/warehouseManipulation-viewModel";

export class CreateWarehouseKeepingView extends View<CreateWarehouseKeepingViewModel>{
    GetViewUniqueId(): string {
        return "V-B8B4D42B-ED70-4144-A247-460ADBA17EE2"
    }
    loadHtml(): string {
        let element = require('./createWarehouseKeeping.html').default;
        let style = require('./createWarehouseKeeping.less');
        return element;
    }
    constructor() {
       super();
    }
    public set isLoading(v: boolean) { this._isLoading = v; } public get isLoading(): boolean { return this._isLoading;} private _isLoading: boolean;
    public set warehouseId(v: string) { this._warehouseId = v; } public get warehouseId(): string { return this._warehouseId;} private _warehouseId: string;
    public set warehouseName(v: string) { this._warehouseName = v; } public get warehouseName(): string { return this._warehouseName;} private _warehouseName: string;
    public set warehouseSelector(v: WarehouseSelectorViewModel) { this._warehouseSelector = v; } public get warehouseSelector(): WarehouseSelectorViewModel { return this._warehouseSelector;} private _warehouseSelector: WarehouseSelectorViewModel;
    public set useDefaultValue(v: boolean) { this._useDefaultValue = v; } public get useDefaultValue(): boolean { return this._useDefaultValue;} private _useDefaultValue: boolean;
    
    save() {
        this.dataContext.save();
    }
    
    back() {
        this.dataContext.back();
    }
 
}
